module.exports = __webpack_public_path__ + "static/player-hero-rob-39ca327b0e7766fa2a8259cbf6e6b6b6.png";